(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lab-password"] && !Shopify.designMode) return;
  try {
    
  // DD:HH:MM:SS until the drop; stops at zero.
  class LabCountdown extends HTMLElement {
    connectedCallback() {
      this.target = new Date(this.dataset.target).getTime();
      this.digits = this.querySelector('.lab-password__digits');
      if (Number.isNaN(this.target)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const left = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
      const parts = [Math.floor(left / 86400), Math.floor(left / 3600) % 24, Math.floor(left / 60) % 60, left % 60];
      this.digits.textContent = parts.map((n) => String(n).padStart(2, '0')).join(':');
      if (left === 0) clearInterval(this.timer);
    }
  }
  if (!customElements.get('lab-countdown')) customElements.define('lab-countdown', LabCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["night-gallery"] && !Shopify.designMode) return;
  try {
    
  // Desktop only: photos can be picked up and moved; the one in hand goes on top.
  class NightTable extends HTMLElement {
    connectedCallback() {
      if (!matchMedia('(min-width: 750px) and (pointer: fine)').matches) return;
      let top = this.children.length + 1;
      for (const item of this.children) {
        item.addEventListener('pointerdown', (event) => {
          event.preventDefault();
          item.setPointerCapture(event.pointerId);
          item.classList.add('is-dragging');
          item.style.zIndex = String(++top);
          const box = this.getBoundingClientRect();
          const startX = event.clientX - item.offsetLeft;
          const startY = event.clientY - item.offsetTop;
          const move = (e) => {
            item.style.left = `${Math.min(Math.max(e.clientX - startX, -40), box.width - 80)}px`;
            item.style.top = `${Math.min(Math.max(e.clientY - startY, -40), box.height - 80)}px`;
          };
          item.addEventListener('pointermove', move);
          item.addEventListener(
            'pointerup',
            () => {
              item.classList.remove('is-dragging');
              item.removeEventListener('pointermove', move);
            },
            { once: true }
          );
        });
      }
    }
  }
  if (!customElements.get('night-table')) customElements.define('night-table', NightTable);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-404"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-open-search]') : null;
    if (!trigger) return;

    const host = /** @type {(HTMLElement & { showDialog?: () => void }) | null} */ (
      document.getElementById('search-modal')
    );
    if (typeof host?.showDialog === 'function') host.showDialog();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-curve"] && !Shopify.designMode) return;
  try {
    
  // Redraws the chromatogram for the chosen hour: one peak per note, height = intensity.
  class ScentCurve extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.notes = Object.keys(this.data[0]?.notes ?? {});
      this.trace = this.querySelector('.scent-curve__trace');
      this.slider = this.querySelector('input[type="range"]');
      this.hourOut = this.querySelector('output');
      this.readout = this.querySelector('.scent-curve__readout');
      const labels = this.querySelector('.scent-curve__labels');
      labels.replaceChildren(
        ...this.notes.map((name) => Object.assign(document.createElement('li'), { textContent: name }))
      );
      this.labels = [...labels.children];
      this.slider.addEventListener('input', () => this.draw());
      this.draw();
    }

    draw() {
      const hour = Number(this.slider.value);
      const values = this.data[hour]?.notes ?? {};
      const step = 1000 / this.notes.length;
      let d = 'M0 200';
      this.notes.forEach((name, i) => {
        const x = step * i + step / 2;
        const top = 200 - (Math.max(0, Math.min(100, values[name] ?? 0)) / 100) * 185;
        const shoulder = top + (200 - top) * 0.15;
        d += ` L${x - step * 0.22} 200 L${x - step * 0.06} ${shoulder} L${x} ${top} L${x + step * 0.06} ${shoulder} L${x + step * 0.22} 200`;
      });
      this.trace.setAttribute('d', `${d} L1000 200`);

      const active = this.notes.filter((name) => (values[name] ?? 0) >= 50);
      this.labels.forEach((li, i) => li.classList.toggle('is-active', active.includes(this.notes[i])));
      this.hourOut.textContent = String(hour);
      this.readout.textContent = `${this.dataset.hourTemplate.replace('[h]', hour)}: ${active.join(' · ') || '—'}`;
    }
  }
  if (!customElements.get('scent-curve')) customElements.define('scent-curve', ScentCurve);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-page"] && !Shopify.designMode) return;
  try {
    
  /** @param {string} text */
  function scentSlug(text) {
    return text
      .toLocaleLowerCase('tr')
      .replace(/ı/g, 'i')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  class ScentPageContent extends HTMLElement {
    /** @type {IntersectionObserver | null} */
    observer = null;

    connectedCallback() {
      const content = /** @type {HTMLElement | null} */ (this.querySelector('[data-content]'));
      if (!content) return;

      if (this.dataset.layout === 'faq') this.buildFaq(content);

      const toc = /** @type {HTMLElement | null} */ (this.querySelector('[data-toc]'));
      if (toc) this.buildToc(content, toc);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    /**
     * Turns each heading and the content that follows it into a <details> disclosure.
     * @param {HTMLElement} content
     */
    buildFaq(content) {
      const children = Array.from(content.children);
      const level = children.some((el) => el.tagName === 'H2') ? 'H2' : 'H3';
      const headings = children.filter((el) => el.tagName === level);

      for (const heading of headings) {
        const details = document.createElement('details');
        details.className = 'scent-faq__item';

        const summary = document.createElement('summary');
        const label = document.createElement('span');
        label.innerHTML = heading.innerHTML;
        const icon = document.createElement('span');
        icon.className = 'scent-faq__icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.append(label, icon);

        const answer = document.createElement('div');
        answer.className = 'scent-faq__answer';
        let next = heading.nextElementSibling;
        while (next && next.tagName !== level) {
          const current = next;
          next = next.nextElementSibling;
          answer.append(current);
        }

        details.append(summary, answer);
        heading.replaceWith(details);
      }
    }

    /**
     * Lists the h2s in the aside and highlights the one being read.
     * @param {HTMLElement} content
     * @param {HTMLElement} toc
     */
    buildToc(content, toc) {
      const headings = Array.from(content.querySelectorAll('h2'));
      const list = toc.querySelector('[data-toc-list]');
      if (headings.length < 2 || !list) return;

      for (const heading of headings) {
        if (!heading.id) {
          const base = scentSlug(heading.textContent || '') || 'section';
          let id = base;
          let suffix = 2;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = (heading.textContent || '').trim();
        item.append(link);
        list.append(item);
      }

      toc.hidden = false;

      const links = Array.from(list.querySelectorAll('a'));
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            for (const link of links) {
              if (link.hash === `#${entry.target.id}`) {
                link.setAttribute('aria-current', 'location');
              } else {
                link.removeAttribute('aria-current');
              }
            }
          }
        },
        { rootMargin: '-15% 0px -70% 0px' }
      );
      headings.forEach((heading) => this.observer?.observe(heading));
    }
  }

  if (!customElements.get('scent-page-content')) customElements.define('scent-page-content', ScentPageContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-rail"] && !Shopify.designMode) return;
  try {
    
  class ScentRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.scent-rail__track');
      this.arrows = Array.from(this.closest('.scent-rail-section')?.querySelectorAll('.scent-rail__arrow') || []);
      this.arrows.forEach((arrow) => arrow.addEventListener('click', this.onArrow));
      this.track?.addEventListener('scroll', this.updateArrows, { passive: true });
      window.addEventListener('resize', this.updateArrows, { passive: true });
      this.updateArrows();
    }

    disconnectedCallback() {
      this.arrows.forEach((arrow) => arrow.removeEventListener('click', this.onArrow));
      this.track?.removeEventListener('scroll', this.updateArrows);
      window.removeEventListener('resize', this.updateArrows);
    }

    onArrow = (event) => {
      const dir = Number(event.currentTarget.dataset.dir) || 1;
      const item = this.track?.querySelector('.scent-rail__item');
      if (!this.track || !item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: dir * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    updateArrows = () => {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.arrows.forEach((arrow) => {
        const dir = Number(arrow.dataset.dir);
        arrow.disabled = dir < 0 ? this.track.scrollLeft <= 0 : this.track.scrollLeft >= max;
      });
    };
  }

  if (!customElements.get('scent-rail')) customElements.define('scent-rail', ScentRail);

  } catch(e) { console.error(e); }
})();
})();
